import { HTMLAttributes, useMemo } from 'react'

export interface CurrencyDisplayProps
  extends HTMLAttributes<HTMLSpanElement> {
  locales?: string | string[]
  currency: string
  /**
   * The value should be in the smallest unit of the currency.
   * ie for £10.20 the value should be 1020
   */
  value?: number
}
export function CurrencyDisplay({
  locales = 'en-GB',
  currency,
  value,
  ...props
}: CurrencyDisplayProps) {
  const format = useMemo(
    () =>
      new Intl.NumberFormat(locales, {
        style: 'currency',
        currency: currency,
      }),
    [currency, locales]
  )
  return typeof value === 'number' ? (
    <span {...props}>
      {format.format(value === 0 ? 0 : value / 100)}
    </span>
  ) : (
    format.formatToParts(0)[0].value
  )
}
